import { SessionJoinState } from "@/modules/coaching/join/enums/SessionJoinState";
import { ShortUrlRenderState } from "@/modules/tracking/consts/ShortUrl";

// JoinNow/ReJoin never actually render the JoinScreen — the loader redirects
// to Meet beforehand — so return `in_progress` in case a caller fires the
// event before the redirect throws.
export function getShortUrlRenderState(
  joinState: SessionJoinState,
): ShortUrlRenderState {
  switch (joinState) {
    case SessionJoinState.NothingYet:
      return "nothing_to_see";
    case SessionJoinState.Early:
      return "early_waiting_room";
    case SessionJoinState.JoinNow:
    case SessionJoinState.ReJoin:
      return "in_progress";
    case SessionJoinState.Missed:
      return "too_late";
    case SessionJoinState.Ended:
      return "session_ended";
  }
}
